import React from "react";

const ThanksForJoining = () => {


    return (
        <section>
            <div className="container-submit">
                <h1 style={{ fontSize: '6rem' }}>Thanks for Joining 😊</h1>
            </div>
        </section>
    )
}

export default ThanksForJoining;